import { IncomingMessage } from 'http'
import { NextApiRequestCookies } from 'next/dist/server/api-utils'
import { v4 } from 'uuid'
import {
  ANGEL_DOMAIN_ANONYMOUS_ID_SYNC_COOKIE,
  ANONYMOUS_ID_HEADER,
  SEGMENT_ANONYMOUS_ID_COOKIE,
} from '@/constants/cookies'
import { logger } from '@/utils/logging'

export function getAnonymousId(req: IncomingMessage & { cookies: NextApiRequestCookies }): {
  anonymousId: string
  shouldSetCookie: boolean
} {
  const anonId = extractAnonymousIdFromRequest(req)

  if (anonId) {
    return { anonymousId: anonId, shouldSetCookie: false }
  } else {
    logger().error('No anonymous ID found in request - fallback will be used in getAnonymousId', { req })
    return { anonymousId: v4(), shouldSetCookie: true }
  }
}

export function getCookie(cookieName: string, cookies?: Partial<{ [key: string]: string }>): string | undefined {
  return cookies?.[cookieName]
}

export function extractAnonymousIdFromRequest(req: IncomingMessage & { cookies: NextApiRequestCookies }) {
  const syncCookie = req.cookies?.[ANGEL_DOMAIN_ANONYMOUS_ID_SYNC_COOKIE]
  if (syncCookie) return syncCookie

  const cookieAnonId = req.cookies?.[SEGMENT_ANONYMOUS_ID_COOKIE]
  if (cookieAnonId) return cookieAnonId

  const headerAnonId = req.headers?.[ANONYMOUS_ID_HEADER]
  if (headerAnonId && typeof headerAnonId === 'string') return headerAnonId

  return null
}
